import type { PropsWithChildren } from 'react';

import { createContext, useContext, useEffect, useState } from 'react';
import {
  matchPath,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';

import { PATH_DASHBOARD } from '../../routes/paths';

type Tab = {
  label: string;
  value: string;
};

export const defaultTabs: Tab[] = [
  {
    label: 'profile',
    value: 'profile',
  },
  // {
  //   value: 'documents',
  //   label: 'documents',
  // },
  {
    label: 'documents',
    value: 'vault',
  },
  {
    label: 'placements',
    value: 'placements',
  },
];

type FosterFamilyDetailsNavigatorContextType = {
  currentTab: string;
  id: string;
  tabs: Tab[];
};

const defaultFosterFamilyDetailsNavigatorContextValue = {
  currentTab: 'profile',
  id: '',
  tabs: defaultTabs,
};

export const FosterFamilyDetailsNavigatorContext =
  createContext<FosterFamilyDetailsNavigatorContextType>(
    defaultFosterFamilyDetailsNavigatorContextValue
  );

type FosterFamilyDetailsNavigatorContextProviderProps = PropsWithChildren<any>;

export const FosterFamilyDetailsNavigatorContextProvider = ({
  children,
}: FosterFamilyDetailsNavigatorContextProviderProps) => {
  const [contextValue, setContextValue] =
    useState<FosterFamilyDetailsNavigatorContextType>(
      defaultFosterFamilyDetailsNavigatorContextValue
    );

  const navigate = useNavigate();
  const { id } = useParams();
  const { pathname } = useLocation();

  useEffect(() => {
    if (id) {
      setContextValue((prev) => ({ ...prev, id }));

      if (pathname) {
        setContextValue((prev) => ({ ...prev }));
      }
    } else {
      navigate(PATH_DASHBOARD.fosterFamily.list);
    }
  }, [id, navigate, pathname]);

  const currentTab =
    contextValue.tabs.find((tab) => {
      if (!id) return false;
      const path = `${PATH_DASHBOARD.fosterFamily.details(id)}/${tab.value}`;
      const match = matchPath({ end: false, path }, location.pathname);
      return !!match;
    }) || defaultTabs[0];

  return (
    <FosterFamilyDetailsNavigatorContext.Provider
      value={{ ...contextValue, currentTab: currentTab.value }}
    >
      {children}
    </FosterFamilyDetailsNavigatorContext.Provider>
  );
};

export const useFosterFamilyDetailsNavigatorContext = () => {
  return useContext(FosterFamilyDetailsNavigatorContext);
};
